export default "__VITE_ASSET__BMjJxASB__"